// We need to set the aria-labels for the next and previous buttons here and not in html
// otherwise props get overridden by swiper
export const getNextAriaLabel = el => el.querySelector('.swiper-button-next').getAttribute('data-aria-next');
export const getPrevAriaLabel = el => el.querySelector('.swiper-button-prev').getAttribute('data-aria-prev');
export const getFirstSlideAriaLabel = el => el.querySelector('.swiper__controls').getAttribute('data-aria-first-slide');
export const getLastSlideAriaLabel = el => el.querySelector('.swiper__controls').getAttribute('data-aria-last-slide');

export const getDefaultSliderSettings = el => {
  return {
    speed: 500,
    watchOverflow: true,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    a11y: {
      prevSlideMessage: getPrevAriaLabel(el),
      nextSlideMessage: getNextAriaLabel(el),
      firstSlideMessage: getFirstSlideAriaLabel(el),
      lastSlideMessage: getLastSlideAriaLabel(el)
    }
  };
};

export const handleAutoplay = (controlBtn, slider) => {
  const svgIcon = controlBtn.querySelector('svg');
  const ariaLabelPlay = controlBtn.getAttribute('data-aria-play');
  const ariaLabelPause = controlBtn.getAttribute('data-aria-pause');

  controlBtn.addEventListener('click', function () {
    if (slider.autoplay.running) {
      slider.autoplay.stop();
      controlBtn.setAttribute('aria-label', ariaLabelPlay);
      svgIcon.innerHTML =
        '<path d="M6 18.0976V5.69802C6 5.35858 6.1198 5.07405 6.35941 4.84443C6.59901 4.61481 6.87855 4.5 7.19802 4.5C7.29786 4.5 7.40269 4.51498 7.51251 4.54493C7.62233 4.57488 7.72715 4.6198 7.82699 4.6797L17.5909 10.8795C17.7706 10.9993 17.9054 11.149 17.9952 11.3287C18.0851 11.5084 18.13 11.6981 18.13 11.8978C18.13 12.0975 18.0851 12.2872 17.9952 12.4669C17.9054 12.6466 17.7706 12.7963 17.5909 12.9161L7.82699 19.1159C7.72715 19.1758 7.62233 19.2207 7.51251 19.2507C7.40269 19.2806 7.29786 19.2956 7.19802 19.2956C6.87855 19.2956 6.59901 19.1808 6.35941 18.9512C6.1198 18.7216 6 18.437 6 18.0976Z" fill="#FFFFFF"/>';
    } else {
      slider.autoplay.start();
      controlBtn.setAttribute('aria-label', ariaLabelPause);
      svgIcon.innerHTML =
        '<path d="M9.33333 4C8.6 4 8 4.45 8 5V19C8 19.55 8.6 20 9.33333 20C10.0667 20 10.6667 19.55 10.6667 19V5C10.6667 4.45 10.0667 4 9.33333 4ZM14.6667 4C13.9333 4 13.3333 4.45 13.3333 5V19C13.3333 19.55 13.9333 20 14.6667 20C15.4 20 16 19.55 16 19V5C16 4.45 15.4 4 14.6667 4Z" fill="#FFFFFF"/>';
    }
  });
};
